import styled from 'styled-components';
import { Divider as DividerMui } from '@mui/material';
import Edit from 'assets/svg/edit.svg';
import EditColored from 'assets/svg/edit-colored.svg';
import { Button as ButtonComponent } from 'components';
import { withTheme } from '@material-ui/core/styles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 20px 30px;
  gap: 20px;
  border-radius: 5px;
`;

export const Divider = styled(DividerMui)`
  border-color: #f4f4f4 !important;
`;

export const EditIconButton = styled.div`
  cursor: pointer;
  width: 29px;
  height: 28px;
  transition: 0.3s;
  background-image: url(${Edit});

  &:hover {
    background-image: url(${EditColored});
  }
`;

export const ObservationText = styled.span`
  display: block;
  margin-top: 8px;
  color: #666666;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
`;

export const Button = withTheme(styled(ButtonComponent)`
  max-width: 200px;
  min-height: 50px;
  && {
    margin-top: ${(props): number => props.theme.spacing(2)}px;
  }
`);

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;
